import { Component, ElementRef, HostListener, Inject, OnChanges, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Observable, Subject, of } from 'rxjs';
import { countries } from 'countries-list';
import _map from 'lodash-es/map';
import _merge from 'lodash-es/merge';
import _keys from 'lodash-es/keys';
import _orderBy from 'lodash-es/orderBy';
import _deburr from 'lodash-es/deburr';
import _find from 'lodash-es/find';
import { first, map, mergeMap, takeUntil, tap, catchError } from 'rxjs/operators';
import * as dayjs from 'dayjs';
import * as utc from 'dayjs/plugin/utc'; // import plugin
import * as timezone from 'dayjs/plugin/timezone'; // import plugin
import { toDMS } from 'maptoolz';

import { BsDatepickerDirective, BsDaterangepickerDirective, DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import { MapInfoWindow, MapMarker, GoogleMap } from '@angular/google-maps'

import SwiperCore, {
	Navigation,
	//Pagination,
	//Scrollbar,
	A11y,
	Lazy,
	SwiperOptions
} from 'swiper/core';


//COMPONENTS
import { AnchorTabsComponent } from 'src/app/shared/anchor-tabs/anchor-tabs.component';

//SERVICES
import { AuthHandlerService } from 'src/app/auth/auth-handler.service';
import { CartService } from 'src/app/shared/services/cart.service';
import { ConfigService } from 'src/app/shared/services/config.service';
import { ConfirmDialogService } from 'src/app/confirm-dialog/confirm-dialog.service';
import { CompassAPICartService } from 'src/app/shared/api-compass/compass-api-cart.service';
import { CompassAPIProductsService } from 'src/app/shared/api-compass/compass-api-products.service';
import { CompassAPIProductSchedulesService } from 'src/app/shared/api-compass/compass-api-product-schedules.service';
import { GoogleCloudService } from 'src/app/shared/services/google-cloud.service';
import { ItineraryService } from 'src/app/shared/services/itinerary.service';
import { MetaService } from 'src/app/shared/services/meta.service';
import { SortService } from 'src/app/shared/services/sort.service';

//PIPES
import { DateMatchPipe } from 'src/app/shared/pipes/date-match.pipe';

//MODELSsrc/app/excursion/excursion-detail/excursion-detail.component.ts
import { ConfirmDialogOptions } from 'src/app/confirm-dialog/confirm-dialog-options.interface';
import { SwiperCardImage } from 'ascedia-design-system/lib/models/swiper-card-image.interface';
import { AnchorTabOptions } from 'src/app/shared/models/anchor-tab-options.interface';
import { Product } from 'src/app/shared/models/product.interface';
import { ProductScheduleOccurrence } from 'src/app/shared/models/product-schedule-occurrence.interface';
import { ProductPricingOption } from 'src/app/shared/models/product-pricing-option.interface';
import { Cart } from 'src/app/shared/models/cart.interface';
import { CartItem } from 'src/app/shared/models/cart-item.interface';
import { Breadcrumb } from 'ascedia-design-system/lib/models/breadcrumb.interface';
import { Location } from 'src/app/shared/models/location.interface';
import { SwiperBackgroundImage } from 'ascedia-design-system/lib/models/swiper-background-image.interface';
import { ProductStatusEnum } from 'src/app/shared/models/product-status.enum';
import { CompassApiGetResults } from 'src/app/shared/models/compass-api-get-results.interface';
import { Itinerary } from 'src/app/shared/models/itinerary.interface';
import { UserAppAccess } from 'src/app/shared/models/user-app-access.interface';
import { Review } from 'src/app/shared/models/review.interface';
import { CompassAPIReviewsService } from 'src/app/shared/api-compass/compass-api-reviews.service';
import { apiConfig, b2cPolicies } from 'src/app/auth/b2c-config';
import { MsalBroadcastService, MSAL_GUARD_CONFIG, MsalGuardConfiguration, MsalService } from '@azure/msal-angular';
import { StorageService } from 'src/app/shared/services/storage.service';
import { AccountInfo, BrowserUtils, InteractionStatus, ServerError, RedirectRequest } from '@azure/msal-browser';


SwiperCore.use([
	Navigation,
	//Pagination,
	//Scrollbar,
	A11y,
	Lazy,
	// Virtual,
	// Zoom,
	// Autoplay,
	// Thumbs,
	// Controller
]);

@Component({
	selector: 'app-excursion-detail',
	templateUrl: './excursion-detail.component.html',
	providers: [ DateMatchPipe ]
})
export class ExcursionDetailComponent implements OnInit, OnChanges {

	public test = 'asdf **asdf** asdf';
	public testReviewDetails = 'This trip was magical from start to finish! I travelled to Barcelona a day early knowing I needed an extra day of sleep to get over jet lag and had an amazing time visiting Park Guell, the Cathedral of Barcelona, and Santa maria del Mar on my own while waiting for the rest of the tour group to arrive. Once they did, the real fun began. From the welcome cocktail to the bus to the airport on the last day, every detail was well thought out and planned. I would recommend this trip to anyone!'

	public pageTake: number = 5;
	public pageLimit: number = this.pageTake;
	public itemsCount: number = 0;
	public hasMoreReviews: boolean = false;
	public sortReviewsBy: string = '';

	public reviews$: Observable<Review[]>;
	public reviews: Review[];
	public reviewLikes: number = 0; 
	public reviewDislikes: number = 0;
	
	public arriveDate:string;

	public regionSlug:string;
	public destinationSlug:string;
	//public productSlug:string;

	public slug:string;

	public product$: Observable<Product>;
	public product: Product;
	//public products$: Observable<Product[]>;//slider at the bottom
	//public destination: Destination;

	public standardCancelationInDays: number = 7;
	public cancelationType: number = 1; //1: no changes, 2: standard days with custom message, 3: custom days w standard msg, 4: custom both

	public occurrences: ProductScheduleOccurrence[];
	public filteredOccurrences: ProductScheduleOccurrence[];
	//public cartOccurrences: Cart;//from storage //ProductScheduleOccurrence[] = [];
	public cart: Cart;//from storage

	public breadcrumbs: Breadcrumb[];

	public countryList = _orderBy(_map(_keys(countries), (key) => {
		return { value: key, text: countries[key].name };
	}), x=> _deburr(x.text));

	public breakpoints = {
		//lowest setting is in markup
		640: { slidesPerView: 2.25, slidesPerGroup: 2, spaceBetween: 10 },
		991: { slidesPerView: 3, slidesPerGroup: 3, spaceBetween: 20 }
	};

	public config: SwiperOptions = {
		// lazy: true,
		// preloadImages: false,
		preloadImages: true,

		freeMode: true,
		//autoHeight: true,
		height: 400,
		slidesPerView: 'auto',
		spaceBetween: 10,
		updateOnImagesReady: true,
		// on:{
		// 	init: function() {
		// 		console.log('SwiperOptions.initialized.'); // this works
		// 	},
		// 	imagesReady: function() {
		// 		console.log('SwiperOptions.images ready.'); // this doesn't work
		// 	}
		// }

	};

	public sliderListBg: SwiperBackgroundImage[];
	public sliderListMore$: Observable<SwiperCardImage[]>;

	public displayMap: boolean = false;
	public mapZoom = 12;
	public mapCenter: google.maps.LatLngLiteral;

	public mapOptions: google.maps.MapOptions;

	public markers: any[];

	public infoContent = '';

	public itinerary: Itinerary = null;

	@ViewChild(MapInfoWindow, { static: false }) info: MapInfoWindow;

	public startDate = new Date();
	public todayDate = new Date();
	public todayPlus1 = new Date();
	public todayPlus2 = new Date();
	public minDate = new Date();
	public maxDate = new Date();
	public searchStartDate = new Date();
	public searchEndDate = new Date();
	public bsRangeValue = [];
	public bsConfig = {
		isAnimated: true,
		containerClass: 'theme-custom',
		showWeekNumbers: false,
		maxDateRange: 7
	}
	public dateCustomClasses: DatepickerDateCustomClasses[];

	public calBtns: any[];
	public calBtnActiveDate: any;
	public buttonSliderX: number = 0;
	public showButtonSliderPrev: boolean = false;
	public showButtonSliderNext: boolean = false;
	public buttonSlideJumpDistance:number = 100;
	public buttonSlideRightPad:number = 50;

	//@ViewChild(BsDaterangepickerDirective, { static: false }) datepicker?: BsDaterangepickerDirective;
	@ViewChild(BsDatepickerDirective, { static: false }) datepicker?: BsDatepickerDirective;
	@ViewChild("buttonSlider") buttonSlider: ElementRef;
	@ViewChild("buttonSliderWrapper") buttonSliderWrapper: ElementRef;
	@ViewChild('signInModalTemplate') signInModalTemplate:any;


	public anchorOptions: AnchorTabOptions = {
		height: 50,
		color: this._configService.colors.primary,
		colorActive: this._configService.colors.primary,
		hideMobile: true
	};
	public anchorTabs: any[] = [
		{
			name: 'Overview',
			id: 'overview',
			isVisible: true
		},
		{
			name: 'Pricing',
			id: 'pricing',
			isVisible: false
		},
		{
			name: 'Details',
			id: 'details',
			isVisible: false
		},
		{
			name: 'Location',
			id: 'location',
			isVisible: false
		},
		{
			name: 'Reviews',
			id: 'reviews',
			isVisible: false
		}
	];
	@ViewChild(AnchorTabsComponent) anchorTabComponent:AnchorTabsComponent;


	public toResize: any;
	public toResizeMs: number = 50;

	modalRef?: BsModalRef;

	public mapsApiLoaded: boolean;
	public userAppAccess: UserAppAccess;

	constructor(
		//private _mockAPIProvider: MockAPIProvider,
		private _authHandlerService: AuthHandlerService,
		private _msalBroadcastService: MsalBroadcastService,
		@Inject(MSAL_GUARD_CONFIG) private _msalGuardConfig: MsalGuardConfiguration,
		private authService: MsalService,
		private _cartService: CartService,
		private _configService: ConfigService,
		private _dateMatchPipe: DateMatchPipe,
		public modalService: BsModalService,
		private _compassAPCartService: CompassAPICartService,
		private _compassAPIProductsService: CompassAPIProductsService,
		private _compassAPIProductSchedulesService: CompassAPIProductSchedulesService,
		private _compassAPIReviewsService: CompassAPIReviewsService,
		private _confirmDialogService: ConfirmDialogService,
		private _googleCloudService: GoogleCloudService,
		private _itineraryService: ItineraryService,
		private _metaService: MetaService,
		private route: ActivatedRoute,
		private router: Router,
		private _sortService: SortService,
		private _storageService: StorageService
		//private scroller: ViewportScroller
	) {

		this.itinerary = this._itineraryService.getItinerary();
		//console.log('ExcursionDetailComponent.itinerary:', this.itinerary);

		this.arriveDate = this.route.snapshot.queryParamMap.get('date');
		//console.log('ExcursionDetailComponent.arriveDate:', this.arriveDate);

		let addDaysForSearch = 4;

		if(this.arriveDate) {
			this.startDate = dayjs(this.arriveDate).subtract(2, 'day').toDate();
			//console.log('ExcursionDetailComponent.todayDate:', this.todayDate);
			addDaysForSearch = 2;
		} else {
			this.startDate = this.todayDate;
		}


		this.todayPlus1 = dayjs(this.todayDate).add(1, 'day').toDate();
		this.minDate = dayjs(this.todayDate).subtract(1, 'year').toDate();
		this.maxDate = dayjs(this.todayDate).add(3, 'year').toDate();
		this.searchStartDate = dayjs(this.startDate).add(2, 'day').toDate();
		this.searchEndDate = dayjs(this.startDate).add(addDaysForSearch, 'day').toDate();
		// console.log('ExcursionDetailComponent.startDate:', this.startDate);
		// console.log('ExcursionDetailComponent.todayPlus1:', this.todayPlus1);
		// console.log('ExcursionDetailComponent.minDate:', this.minDate);
		// console.log('ExcursionDetailComponent.maxDate:', this.maxDate);
		// console.log('ExcursionDetailComponent.searchStartDate:', this.searchStartDate);
		// console.log('ExcursionDetailComponent.searchEndDate:', this.searchEndDate);

		this.bsRangeValue = [this.searchStartDate, this.searchEndDate];

		this.dateCustomClasses = [
			//{ date: this.todayDate, classes: [] },
			{ date: this.todayDate, classes: ['bg-danger', 'text-warning'] },
			{ date: this.todayPlus1, classes: ['bg-warning'] },
			// { date: twoDaysAhead, classes: ['has-event'] },
			// { date: fourDaysAhead, classes: ['has-event'] },
			// { date: yesterday, classes: ['has-event'] },
			// { date: this.nextWeek, classes: ['has-event'] }
		];



	}

	ngOnInit(): void {
		this.userAppAccess = this._authHandlerService.getUserAppAccess();
		//console.log('userAppAccess: ', this.userAppAccess);

		dayjs.extend(utc);
		dayjs.extend(timezone);

		this.slug = this.route.snapshot.paramMap.get('slug');
		this.regionSlug = this.route.snapshot.paramMap.get('regionSlug');
		this.destinationSlug = this.route.snapshot.paramMap.get('destinationSlug');
		//console.log('url:', this.regionSlug, this.destinationSlug, this.slug);

		this.route.data
			.subscribe((data: { product: Product }) => {
				this.processData(data.product);
			});

		this.initGoogleMaps();
	}

	ngOnChanges():void{
		//console.log('ngOnChanges.ExcursionDetailComponent:');
	}



	@HostListener('window:resize', ['$event'])
	onResizeEvent() {
		clearTimeout(this.toResize);
		this.toResize = setTimeout(()=>{
			this.datepicker?.hide();
			this.buttonSlide(0);
		}, this.toResizeMs);
	}


	@HostListener('window:scroll', ['$event'])
	onScrollEvent() {
		clearTimeout(this.toResize);
		this.toResize = setTimeout(()=>{
			this.datepicker?.hide();
		}, this.toResizeMs);
	}




	public initGoogleMaps(){
		this.mapsApiLoaded = this._googleCloudService.getMapsApiLoaded();
		//console.log('ExcursionDetailComponent.initGoogleMaps.mapsApiLoaded:', this.mapsApiLoaded);

		if(!this.mapsApiLoaded){
			this._googleCloudService.loadGoogleMapsAPI()
				.then((res: boolean) => {
					this.setGoogleMapOptions();
					this.mapsApiLoaded = res;
					//console.log('loadGoogleMapsAPI.mapsApiLoaded:', this.mapsApiLoaded);
				})
				.catch((err: any) => {
					console.error('loadGoogleMapsAPI.err', err);
				});
		} else {
			this.setGoogleMapOptions();
		}
	}

	public setGoogleMapOptions() {
		this.mapOptions = {
			mapTypeId: google.maps.MapTypeId.ROADMAP,
			zoomControl: true,
			scrollwheel: true,
			disableDoubleClickZoom: true,
			maxZoom: 16,
			minZoom: 3,
		};
	}




	/**
	 * Process data
	 * @param data
	*/
	public processData(data: Product) {
		//console.log('processData', data);
		let country = this.countryList.find(x => x.value == data.destination.countryCode);
		//console.log('country:', country);
		data.destination.countryName = country.text;

		data.useName = data.displayName ? data.displayName : data.name;
		this._metaService.updateMetaData(data.useName, data.metaData);

		this.product = data;
		if(!this.product.isCancellable){
			this.cancelationType = 0;
		}
		else if(this.product.minimumCancelationInDays == this.standardCancelationInDays && this.product.cancellationPolicy.trim() != '') {
			this.cancelationType = 2;
		} else if (this.product.minimumCancelationInDays > this.standardCancelationInDays && this.product.cancellationPolicy.trim() == '') {
			this.cancelationType = 3;
		} else if (this.product.minimumCancelationInDays > this.standardCancelationInDays && this.product.cancellationPolicy.trim() != '') {
			this.cancelationType = 4;
		}

		if(this.product.assets && this.product.assets.length > 0) {
			this.sliderListBg = [];
			this.product.assets.forEach(asset => {
				if(asset.type == 'IMAGE'){
					let assetNameArr = asset.name.split('/'),
						assetName = assetNameArr[assetNameArr.length - 1];
					this.sliderListBg.push({
						image: asset.url + '?w=400&scale=both',
						image2x: asset.url + '?w=1200&scale=both',
						href: asset.url,
						imageAlt: assetName,
						target: '_blank'
					});
				}
			});
		}

		this.breadcrumbs = [
			{
				title: 'Destinations',
				href: '/destinations'
			},
			{
				title: this.product.destination.region.name,
				href: '/destinations/' + this.product.destination.region.slug
			},
			{
				title: this.product.destination.name,
				href: '/destinations/' + this.product.destination.region.slug + '/' + this.product.destination.slug
			},
			{
				title: this.product.useName
			}
		];

		this.getProductScheduleOccurrences();

		if(this.product.locations && this.product.locations[0]?.address?.latLng) {

			//console.log('latLng:', location.address.latLng);
			//console.log('latLng.toDMS:', toDMS([location.address.latLng.lat, location.address.latLng.lng]));
			this.product.locations.forEach(location => {

				location.address.addressDisplay = '';
				//if(location.name) location.address.addressDisplay += '<b>' + location.name + '</b><br/>';
				if(location.address.streetAddress) location.address.addressDisplay += '' + location.address.streetAddress;
				if(location.address.extendedAddress) location.address.addressDisplay += ' ' + location.address.extendedAddress;
				if(location.address.locality) location.address.addressDisplay += ' &nbsp;&nbsp; ' + location.address.locality;
				if(location.address.region) location.address.addressDisplay += ', ' + location.address.region;
				if(location.address.postalCode) location.address.addressDisplay += ' ' + location.address.postalCode;
				if(location.address.country) location.address.addressDisplay += ' ' + location.address.country;

				if(location.address.latLng){
					let dmsArr = toDMS([location.address.latLng.lat, location.address.latLng.lng]);
					location.address.latLngDisplay = dmsArr[0].lat + ' ' + dmsArr[0].long;
					//console.log('location.address.latLngDisplay', location.address.latLngDisplay);
					location.address.addressDisplay += '<br/><span class="text-small">' + location.address.latLngDisplay + '</span>';
				}
				//console.log('location.address.addressDisplay', location.address.addressDisplay);
			});

			this.initializeMap();
		}

		this.getProductsByDestination(this.product.destination.id);

		this.cart = this._cartService.getCart();
		this.getReviews();
	}


	public getProductScheduleOccurrences() {
		const startDateStr = dayjs(this.searchStartDate).format('YYYY-MM-DD'),
			endDateStr = dayjs(this.searchEndDate).format('YYYY-MM-DD');
		//console.log('searchDates', startDateStr, endDateStr);

		this._compassAPIProductSchedulesService.getProductScheduleOccurrences(this.product.id, startDateStr, endDateStr, null, true)
			.subscribe((res: ProductScheduleOccurrence[]) => {
				//console.log('getProductScheduleOccurrences.res', res);
				if(res) {
					this.processOccurrences(res);
				}
			}, (err) => {
				console.error('getProductScheduleOccurrences.err', err);
			});
	}

	public getReviews () {
		const searchStr: string = null,
			productId: string = (this.product.id != '') ? this.product.id : null,
			status: string = 'APPROVED', 
			isLikedSort: boolean = (this.sortReviewsBy == "liked") ? true : false, 
			isDislikedSort: boolean = (this.sortReviewsBy == "disliked") ? true : false ;
		
		const r = this._compassAPIReviewsService.getReviews(searchStr, productId, status, this.pageLimit, null, isLikedSort, isDislikedSort )
			.pipe(map((res: CompassApiGetResults) => {
				//this.loadingMsg = '';
				if(res && res.results && res.results.length > 0) {
					this.itemsCount = res.total;
					return this.processReviewData(res);
				}
				return null;
			})).subscribe();
	}

	public sortReviews(value: any){
		this.sortReviewsBy = value.target.value.toLowerCase();		
		this.getReviews()
	}
	
	public loadMoreReviews(){
		this.pageLimit += this.pageTake;
		this.getReviews();
	}

	public processReviewData(res) {//reviews: Review[]
		console.log(res);
		this.reviews = res.results;
		this.reviewDislikes = res.dislikes; 
		this.reviewLikes = res.likes;
		this.hasMoreReviews = res.results.length < res.total; 
	}


	/**
	 * Process Occurrences
	 * @param data
	*/
	public processOccurrences(data: ProductScheduleOccurrence[]) {
		//console.log('processOccurrences', data);

		this.product.startingAt = 0;


		//loop through cart.items for ones with quantity, push into array
		let tempArr = [];
		if(this.cart && this.cart?.items && this.cart?.items?.length > 0) {
			this.cart.items.forEach(item => {
				//console.log('cart.item', item);
				item.pricingOptions.forEach(option => {
					//console.log('cart.item.option', option);
					if(option.quantity > 0){
						//console.log('add to cart ^^');
						tempArr.push({productScheduleId: item.productScheduleId, date: item.date, option: option});
					}
				});
			});
		}
		//console.log('tempArr', tempArr);

		data.forEach(occurrence => {
			occurrence.useName = (occurrence.displayName) ? occurrence.displayName : occurrence.scheduleName;
			occurrence.isUnsaved = false;
			occurrence.alreadyInCart = false;
			occurrence.wasJustAdded = false;
			//console.log('occurrence:', occurrence);

			const startTimeUtc = occurrence.startTime ? dayjs(occurrence.startTime).utc().format('h:mm a') : null;
			//console.log('startTime:', occurrence.startTime, '->', startTimeUtc);
			occurrence.startTimeUtc = startTimeUtc;

			if(occurrence.productPricingOptions){
				occurrence.productPricingOptions.forEach(pricingOption => {
					//console.log('-- pricingOption:', pricingOption);

					//if current option is in the cart already, update the quantity
					let foundCartOption = tempArr.find(x =>
						x.option.productPricingOptionId == pricingOption.id &&
						dayjs(x.date).format('YYYY-MM-DD') == dayjs(occurrence.date).format('YYYY-MM-DD') &&
						x.productScheduleId == occurrence.productScheduleId
					);


					if(foundCartOption) {
						occurrence.alreadyInCart = true;
						pricingOption.quantity = foundCartOption.option.quantity;
					} else {
						pricingOption.quantity = 0;
					}

					pricingOption.useName = (pricingOption.displayName) ? pricingOption.displayName : pricingOption.name;
					//console.log('pricingOption:', pricingOption.displayPrice, 'vs', occurrence.startingAt);
					if(!occurrence.startingAt || occurrence.startingAt > pricingOption.displayPrice) occurrence.startingAt = pricingOption.displayPrice;
					if(!this.product.startingAt || this.product.startingAt > pricingOption.displayPrice) this.product.startingAt = pricingOption.displayPrice;
				});

				//console.log('occurrence.productPricingOptions UNsorted', JSON.stringify(occurrence.productPricingOptions));
				occurrence.productPricingOptions = this._sortService.sortArray(occurrence.productPricingOptions, ['sortOrder']);
				//console.log('occurrence.productPricingOptions Sorted', JSON.stringify(occurrence.productPricingOptions));
			}

			//console.log('occurrence', occurrence);
		});
		if(data[0]) data[0].isVisible = true;

		this.occurrences = data;

		if(this.cart && this.cart?.items && this.cart?.items.length > 0) {
			this.checkTicketsForAddToCartButton();
		}

		this.buildCalendarButtons();


	}



	public buildCalendarButtons(){
		//console.log('buildCalendarButtons()');
		let date1 = dayjs(this.searchStartDate),
			date2 = dayjs(this.searchEndDate),
			daysDiff = date2.diff(date1, 'day'),
			foundDate = this.occurrences.find(x => dayjs(x.date).format('YYYY-MM-DD') == dayjs(this.searchStartDate).format('YYYY-MM-DD')),
			isDisabled = (foundDate) ? false : true;
		//console.log('daysDiff:', daysDiff);
		//console.log('foundDate:', foundDate);

		this.calBtns = [{date: new Date(this.searchStartDate), isActive: true, isDisabled: isDisabled}];

		for(let i = 1; i <= daysDiff; i++){
			let prevDate = new Date(this.calBtns[i - 1].date),
				nextDate = dayjs(prevDate).add(1, 'day'),
				foundDate = this.occurrences.find(x => dayjs(x.date).format('YYYY-MM-DD') == dayjs(nextDate).format('YYYY-MM-DD')),
				isDisabled = (foundDate) ? false : true;

			// console.log('this.calBtns[i - 1].date:', this.calBtns[i - 1].date);
			// console.log('prevDate:', prevDate);
			// console.log('nextDate:', nextDate);
			// console.log('foundDate:', foundDate);

			this.calBtns.push({date: nextDate, isActive: false, isDisabled: isDisabled});
		}
		//console.log('calBtns:', this.calBtns);

		this.calBtnActiveDate = dayjs(this.calBtns[0].date).format('YYYY-MM-DD');

		this.filterOccurrencesByDate();
	}

  //FILTER OCCURANCES BY DATE
	public filterOccurrencesByDate(){
		//console.log('filterOccurrencesByDate()');

		this.filteredOccurrences = this._dateMatchPipe.transform(this.occurrences, this.calBtnActiveDate);

		if(this.filteredOccurrences[0]) this.filteredOccurrences[0].isVisible = true;

		// console.log('occurrences:', this.occurrences);
		//console.log('filteredOccurrences:', this.filteredOccurrences);

		clearTimeout(this.toResize);
		this.toResize = setTimeout(()=>{
			this.buttonSlide(0);
		}, this.toResizeMs);
	}



	public setActiveCalendarButton(activateBtn: any) {
		//console.log('setActiveCalendarButton()');
		this.calBtns.forEach(btn => {
			if(btn == activateBtn) {
				btn.isActive = true;
				this.calBtnActiveDate = dayjs(btn.date).format('YYYY-MM-DD');
			} else {
				btn.isActive = false
			}
		});
		this.filterOccurrencesByDate();
	}


	public buttonSlide(dir:number){
		//console.log('buttonSlide()', dir);

		if(!this.buttonSliderWrapper) return;

		const buttonSliderWrapperRect = this.buttonSliderWrapper.nativeElement.getBoundingClientRect(),
			buttonSliderRect = this.buttonSlider.nativeElement.getBoundingClientRect(),
			relativePosLeft = buttonSliderRect.left - buttonSliderWrapperRect.left,
			newX = (dir * this.buttonSlideJumpDistance) + relativePosLeft,
			minX = 0 - buttonSliderRect.width + buttonSliderWrapperRect.width - this.buttonSlideRightPad,
			maxX = 0,
			isWider = buttonSliderRect.width > buttonSliderWrapperRect.width;

		if(newX > maxX || !isWider) {
			this.buttonSliderX = maxX;
		} else if (newX < minX) {
			this.buttonSliderX = minX;
		} else {
			this.buttonSliderX = newX;
		}

		if(isWider && this.buttonSliderX != maxX) {
			this.showButtonSliderPrev = true;
		} else {
			this.showButtonSliderPrev = false;
		}
		if(isWider && this.buttonSliderX != minX) {
			this.showButtonSliderNext = true;
		} else {
			this.showButtonSliderNext = false;
		}


	}









	public onDateChange(evt) {
		//console.log('onDateChange.evt:', evt);
		this.searchStartDate = evt[0];
		this.searchEndDate = evt[1];
		if(this.product) this.getProductScheduleOccurrences();
	}

	public toggleOccurrence(occurrence: ProductScheduleOccurrence) {
		occurrence.isVisible = !occurrence.isVisible;
		//console.log('toggleOccurrence', occurrence);

	}

	public openSignInModal(template: TemplateRef<any>) {
		//console.log('openSignInModal');
		this.modalRef?.hide();
		const initialState = {
			//test: 'asdf',
		};
		this.modalRef = this.modalService.show(template, {initialState, animated: false, class: 'mw-400'});
	}
		
	public signIn() {
		//console.log('signIn');
		let userFlowRequest = {
			scopes: apiConfig.scopes,
			authority: b2cPolicies.authorities.signUpSignIn.authority
		};
		if (this._msalGuardConfig.authRequest){
			this.authService.loginRedirect({...this._msalGuardConfig.authRequest, ...userFlowRequest, extraQueryParameters: {
				cart: JSON.stringify(this._storageService.getCart())
			}} as RedirectRequest);
		} else {
			this.authService.loginRedirect();
		}
	}

	public createAccount() {
		//console.log('createAccount');
		let userFlowRequest = {
			scopes: apiConfig.scopes,
			authority: b2cPolicies.authorities.signUp.authority
		};
		if (this._msalGuardConfig.authRequest){
			this.authService.loginRedirect({...this._msalGuardConfig.authRequest, ...userFlowRequest });
		} else {
			this.authService.loginRedirect();
		}
	}
	/**
	 * Add to Cart / Update cart
	 * @param occurrence
	 */
	public addToCart(occurrence: ProductScheduleOccurrence) {
		//console.log('addToCart', occurrence);
		let activeAcccount = this._authHandlerService.activeAccount(); 
		if(!activeAcccount){			
			this.openSignInModal(this.signInModalTemplate);
			return;
		}

		if(this.cart){
			//cart already exists
			if(!this.cart.items) this.cart.items = [];
		} else {
			//create cart
			this.cart = {
				items: []
			}
		}

		//if(!this.cart.userId) this.cart.userId = '29618167-e52b-4fa8-b1da-21bda72d9a02';
    	this._cartService.checkCartStorage();

		//console.log('cart1:', this.cart);

		//NEED TO LOOP THROUGH occurrence.productPricingOptions AND ADD ANY TO THE CART THAT ARE NOT THERE.
		var updateItem; 
		occurrence.productPricingOptions.forEach(option => {
			if(option.quantity > 0) {
				//console.log('option:', option);

				//let foundInCart = this.cart.items.find(item => item.productScheduleId != occurrence.productScheduleId && dayjs(item.date).format('YYYY-MM-DD') != dayjs(occurrence.date).format('YYYY-MM-DD'));

				//need to look for the productPricingOptionId also
				let foundOccurrenceInCart = this.cart.items.find(item => item.productScheduleId == occurrence.productScheduleId && item.date == occurrence.date);
				//console.log('foundOccurrenceInCart:', foundOccurrenceInCart);

				let foundOptionInCart = foundOccurrenceInCart?.pricingOptions.find(item => item.productPricingOptionId == option.id);
				//console.log('foundOptionInCart:', foundOptionInCart);
				// for(let i = 0; i < foundOccurrenceInCart?.pricingOptions.length; i++){
				// 	console.log('compare options: ', foundOccurrenceInCart?.pricingOptions[i].productPricingOptionId , 'vs', option.id);
				// }
				
				if(foundOccurrenceInCart && foundOptionInCart){
					//update quantity
					foundOptionInCart.quantity = option.quantity;
					updateItem = foundOccurrenceInCart;
				} else if(foundOccurrenceInCart) {
					let newCartItemOption: ProductPricingOption = {
						name: option.name,
						displayName: option.displayName,
						shortDescription: option.shortDescription,
						displayPrice: option.displayPrice,
						quantity: option.quantity,
						productPricingOptionId: option.id
					};
					foundOccurrenceInCart.pricingOptions.push(newCartItemOption);
					updateItem = foundOccurrenceInCart;

				} else {
					//add new item

					let newCartItem: CartItem = {
						date: occurrence.date,
						productId: this.product.id,
						productName: this.product.name,
						productDisplayName: this.product.displayName,
						duration: this.product.duration,
						productScheduleId: occurrence.productScheduleId,
						productScheduleName: occurrence.scheduleName,
						productScheduleDisplayName: occurrence.displayName,
						startTime: occurrence.startTime,
						otherStartTime: occurrence.otherStartTime,
						cartId: this.cart.id,
						pricingOptions: [
							{
								name: option.name,
								displayName: option.displayName,
								shortDescription: option.shortDescription,
								displayPrice: option.displayPrice,
								quantity: option.quantity,
								productPricingOptionId: option.id
							}
						]
					};
					//console.log('newCartItem', newCartItem);

					this.cart.items.push(newCartItem);
					updateItem = newCartItem;
				}


			}
		});

		occurrence.alreadyInCart = true;
		occurrence.isUnsaved = false;
		this.justAddedTimer(occurrence);

		//console.log("occurence: ", occurrence);
		//console.log('cart2:', this.cart);
		
		this.saveCart(updateItem);
	}


	public justAddedTimer(occurrence: ProductScheduleOccurrence) {
		//console.log('justAddedTimer()', occurrence);
		occurrence.wasJustAdded = true;

		setTimeout(() => {
			//console.log('justAddedTimer.done');
			occurrence.wasJustAdded = false;
		}, 5000);
	}


	public goToCart() {
		this.router.navigate(['/cart']);
	}


	public saveCart(item) {
		//console.log('saveCart()', this.cart);

		//this._cartService.saveCart(this.cart);//<-- this would be better.

		this._cartService.setCart(this.cart);
		let activeAcccount = this._authHandlerService.activeAccount();
		//console.log('activeAcccount', activeAcccount);
		
		if(activeAcccount) {
			if(!this.cart.id) {
				this._compassAPCartService.postCart(this.cart)
					.pipe(first())
					.subscribe((res: any) => {
						console.log('postCart.res', res);
						if(!res.error) {
							this.cart = res;
							this._cartService.setCart(this.cart);
						}
					});

			}
			else if(item.id){
				this._compassAPCartService.postCartItem(item).subscribe((res: any) => {
					if(!res.error) {
						this.cart = res;
						this._cartService.setCart(this.cart);
					}
				})
			}
			else {
				this._compassAPCartService.putCartItem(item).subscribe((res: any) => {
					if(!res.error) {
						this.cart = res;
						this._cartService.setCart(this.cart);
					}
				})
			}
		// 	//post/put to API

		// 	 else {
		// 		//console.log('putCart.cart', this.cart);

		// 		this._compassAPCartService.putCart(this.cart)
		// 			.pipe(first())
		// 			.subscribe((res: any) => {
		// 				console.log('putCart.res', res);
		// 				if(!res.error) {
		// 					this.cart = res;
		// 					this._cartService.setCart(this.cart);
		// 				}
		// 			});

		// 	}


		} else {
			return;//only save localy
		}


	}



	public clearCart() {
		//console.log('clearCart');
		this.occurrences.forEach(occurrence => {
			//console.log('occurrence', occurrence);
			occurrence.totalPrice = 0;
			occurrence.isAddToCartActive = false;
			occurrence.productPricingOptions.forEach(option => {
				//console.log('option', option);
				option.quantity = 0;
			});
		});

		//this.cart = null;
		this.cart = {
			//userId: '29618167-e52b-4fa8-b1da-21bda72d9a02',
			cartTotal: 0,
			items: []
		}
		this._cartService.clearCart();
	}



	public closeTicketModal(){
		this.modalRef?.hide();
	}

	//https://stackoverflow.com/questions/62725266/pass-data-to-modal-using-ngx-bootstrap-modal
	public openTicketsModal(template: TemplateRef<any>, occurrence: ProductScheduleOccurrence) {//pack: TicketPackage
		//console.log('openTicketsModal', occurrence);
		this.modalRef?.hide();
		const initialState = {
			//bio: bio,
			//test: 'asdf',
			//tickets: pack.tickets,
			occurrence: occurrence
		};
		this.modalRef = this.modalService.show(template, {initialState, animated: false, class: 'tickets-modal'});
	}



	/**
	 * Edit ticket - add/remove item from ticketpackage
	 * @param option
	 * @param action
	*/
	public editOption(option: ProductPricingOption, action: 'add'|'remove', occurrence: ProductScheduleOccurrence) {
		//console.log('editTicket:', option, action, occurrence);

		if(action == 'add') {
			occurrence.isUnsaved = true;
			option.quantity ++;
			this.checkTicketsForAddToCartButton();
		} else{

			if(option.quantity == 1) {
				//TODO-JK: if option was in cart and then removed, need to update cart, only if it was in cart

				if(!this.cart?.items || this.cart.items.length == 0) {
					occurrence.isUnsaved = true;
					option.quantity --;
					this.checkTicketsForAddToCartButton();
					return;
				}

				let foundOccurrenceInCart = this.cart.items.find(item => item.productScheduleId == occurrence.productScheduleId && item.date == occurrence.date);
				//console.log('foundOccurrenceInCart:', foundOccurrenceInCart);

				let foundOptionInCart = foundOccurrenceInCart?.pricingOptions.find(item => item.productPricingOptionId == option.id);
				//console.log('foundOptionInCart:', foundOptionInCart);

				if(foundOptionInCart) {
					this.confirmRemoveFromCart(option, occurrence);
				} else {
					occurrence.isUnsaved = true;
					option.quantity --;
					this.checkTicketsForAddToCartButton();
				}

			} else if(option.quantity > 1) {
				occurrence.isUnsaved = true;
				option.quantity --;
				this.checkTicketsForAddToCartButton();
			}
		}

	}


	public confirmRemoveFromCart(pricingOption: ProductPricingOption,  occurrence: ProductScheduleOccurrence) {
		//console.log('confirmRemoveFromCart()');
		let that = this;
		const options: ConfirmDialogOptions = {
			title: "Are you sure you want to remove this from your cart?",
			btn2Class: "btn-danger"
		};
		this._confirmDialogService.confirmThis(options, function () {
			//console.log("Yes clicked");
			//that.modalRef?.hide();
			that.removeFromCart(pricingOption, occurrence);

		}, function () {
			//console.log("No clicked");
		});
	}


	public removeFromCart(pricingOption: ProductPricingOption,  occurrence: ProductScheduleOccurrence){
		//console.log('removeFromCart:', pricingOption, occurrence);
		pricingOption.quantity --;
		this.checkTicketsForAddToCartButton();

		this.cart = this._cartService.removeOptionFromCart(pricingOption, occurrence);
		//console.log('cart:', this.cart);

		//this.saveCart();

	}


	public checkIfAnyUnsaved() {
		//console.log('checkIfAnyUnsaved()');
		this.occurrences.forEach( item => {
			if(item.isUnsaved) return true;
		});
		return false;
	}




	/**
	 * check tickets to see if at least one has been added, then activate add to cart button
	*/
	public checkTicketsForAddToCartButton () {
		//console.log('checkTicketsForAddToCartButton()');

		this.occurrences.forEach(occurrence => {
			//console.group('occurrence', occurrence);
			occurrence.totalPrice = 0;
			occurrence.isAddToCartActive = false;
			occurrence.productPricingOptions.forEach(option => {
				//console.log('option', option);
				if(option.quantity > 0) {
					occurrence.isAddToCartActive = true;
					occurrence.totalPrice += (option.displayPrice * option.quantity);
				}
			});

			//console.groupEnd();
		});
	}


	/**
	 * Update child component
	 * @param id
	*/
	public anchorTabClick(id:string) {
		this.anchorTabComponent.scrollTo(id);
	}





	public getProductsByDestination(destId: string){

		this.sliderListMore$ = this._compassAPIProductsService.getProducts(null, null, destId, ProductStatusEnum.live)
			.pipe(map((res: CompassApiGetResults) => {
				//console.log('getProductsByDestination:', res);
				if(res && res.results && res.results.length > 0) {
					//this.itemsCount = res.total;
					let products: Product[] = res.results,
						slides: SwiperCardImage[];

					products.forEach(product => {
						//console.log('product:', product);
						product.useName = product.displayName ? product.displayName : product.name;
						product.isFavorite = false;
						product.slugPath = '/excursions/' + product.destination.region.slug + '/' + product.destination.slug + '/' + product.slug;
						if(!product.assets[0]){
							product.assets.push({name: 'defaultImage', url: this._configService.images.defaultImage});
						}

						let slide: SwiperCardImage = {
							title: product.useName,
							subTitle: product.destination.name + ', ' + product.destination.region.name,
							image: product.assets[0].url + '?w=175&h=120&mode=crop&scale=both',
							image2x: product.assets[0].url + '?w=350&h=240&mode=crop&scale=both',
							imageAlt: product.name,
							href: product.slugPath
						};

						if(product.id != this.product.id) {
							if(!slides) slides = [];
							slides.push(slide);
						}

					});
					//console.log('sliderListMore:', slides);
					return slides;
				}
				return null;
			}));

	}





	public initializeMap() {

		// let staticUrl = new URL('https://maps.googleapis.com/maps/api/staticmap');
		// staticUrl.searchParams.append('zoom', '13');
		// staticUrl.searchParams.append('size', '800x300');
		// staticUrl.searchParams.append('maptype', google.maps.MapTypeId.ROADMAP);
		// staticUrl.searchParams.append('key', 'AIzaSyAcHmRsmWZXC4eCpom8pKhKtIVkMDOauCo');

		this.product.locations.forEach((location: Location) => {
			//console.log('location:', location);

			if(location.address.latLng){

				let marker = {
					title: location.name,
					position: {
						lat: location.address.latLng.lat,
						lng: location.address.latLng.lng
					},
					info: ''
					//info: '<b>' + location.name + '</b><br/>' + location.address.streetAddress + ' ' + location.address.extendedAddress + '<br/>' + location.address.locality + ', ' + location.address.region + ' ' + location.address.postalCode + ' ' + location.address.country
				};

				if(location.name) marker.info += '<b>' + location.name + '</b><br/>';
				if(location.address.streetAddress) marker.info += '' + location.address.streetAddress + '';
				if(location.address.extendedAddress) marker.info += ' ' + location.address.extendedAddress + '';
				if(location.address.locality) marker.info += '<br/>' + location.address.locality + '';
				if(location.address.region) marker.info += ', ' + location.address.region + '';
				if(location.address.postalCode) marker.info += ' ' + location.address.postalCode + '';
				if(location.address.country) marker.info += ' ' + location.address.country + '';

				if(!this.markers) this.markers = [];
				this.markers.push(marker);
			}

			// staticUrl.searchParams.append('markers', 'color:' + this.staticMapLabels[this.markers.length - 1].color + '|label:' + this.staticMapLabels[this.markers.length - 1].title + '|' + location.address.latLng.lat + ',' + location.address.latLng.lng);
			// // console.log('color:' + this.staticMapLabels[this.markers.length - 1].color + '%7Clabel:' + this.staticMapLabels[this.markers.length - 1].title + '%7C' + location.address.latLng.lat + ',' + location.address.latLng.lng);
		});

		if(this.markers) {
			this.mapCenter = {
				lat: this.markers[0].position.lat,
				lng: this.markers[0].position.lng
			};
			//staticUrl.searchParams.append('center', this.markers[0].position.lat + ',' + this.markers[0].position.lng);
		}

		//this.staticMapStr = String(staticUrl);
		//console.log('this.staticMapStr:', this.staticMapStr);

		this.displayMap = true;

	}

	public openInfo(marker: MapMarker, content) {
		//console.log('openInfo:', marker, content);
		this.infoContent = content;
		this.info.open(marker);
	}

	public getGoogleMapsLocUrl(location: Location){
		//http://maps.google.com/?q=1200 Pennsylvania Ave SE, Washington, District of Columbia, 20003
		let mapUrl: string = 'http://maps.google.com/?q=';
		if(location.name) mapUrl += location.name + ' ';
		if(location.address.streetAddress) mapUrl += location.address.streetAddress;
		if(location.address.locality) mapUrl += ' ' + location.address.locality;
		if(location.address.region) mapUrl += ', ' + location.address.region;
		if(location.address.region) mapUrl += ' ' + location.address.postalCode;
		if(location.address.country) mapUrl += ' ' + location.address.country;
		//window.open(mapUrl);
		return mapUrl;

		// let mapUrl: string = 'https://www.google.com/maps/search/?api=1&query=' + location.address.latLng.lat + ',' + location.address.latLng.lng + '';
		// window.open(mapUrl);
	}

}
